import { getCurrentPolicyVersion } from "@/lib/helpers/getCurrentPolicyVersion";
import { HIPAA, PRIVACY, TERMS_AND_CONDITIONS } from "@/core/constants";

import { createAcknowledgement, createAcknowledgementV2 } from "./acknowledgementUtils";

/**
 * @deprecated This function is only asynchronous due to fetching of client IP, which we no longer
 * do, see https://aptihealth.atlassian.net/issues/AT1-6695. Use createImplicitConsentV2 instead
 */
export const createImplicitConsent = async (policyMetadata) => {
  const acknowledgement = await createAcknowledgement({ consentResponse: true });

  return {
    eula: [
      {
        ...acknowledgement,
        version: getCurrentPolicyVersion({ policy: "TERMS_AND_CONDITIONS", policyMetadata }),
      },
    ],
    hipaa: [
      { ...acknowledgement, version: getCurrentPolicyVersion({ policy: "HIPAA", policyMetadata }) },
    ],
    privacy: [
      {
        ...acknowledgement,
        version: getCurrentPolicyVersion({ policy: "PRIVACY", policyMetadata }),
      },
    ],
  };
};

export const createImplicitConsentV2 = (policyMetadata, isGivenOnBehalf = false) => {
  const policyMapping = {
    eula: TERMS_AND_CONDITIONS,
    hipaa: HIPAA,
    privacy: PRIVACY,
  };

  return Object.fromEntries(
    Object.entries(policyMapping).map(([key, value]) => [
      key,
      [
        createAcknowledgementV2({
          isGivenOnBehalf,
          policyVersion: policyMetadata[value]?.current_version,
        }),
      ],
    ]),
  );
};

function createPolicyConsentEntry(
  targetPatientId,
  consent,
  consentType,
  impliedConcentPolicyVersion,
) {
  return {
    consent,
    consent_type: consentType,
    implied_consent_policy_versions: impliedConcentPolicyVersion,
    target_patient_id: targetPatientId,
  };
}
